// LED electrics for the lamp templates: 24-V supplies with checked sizes, dimmers, strip
// options, and the pick of the supply that fits the load and the space best.

// Constant-voltage 24-V supplies, Schutzklasse II. Sizes from the makers' data sheets,
// overall with the mounting ears: L along the cable direction, T = height lying flat.
// `end`: free room each terminal end needs for the wires (cable exits or screw terminals).
export const SUPPLIES = [
  { id: 'apv8', name: 'Mean Well APV-8-24', w: 8, L: 73, W: 35, T: 23.5, end: 12, price: 9, note: '8 W, 0,34 A, Gehäuse 60 × 30 × 23,5 mm, mit Befestigungslaschen 73 × 35 mm (Lochabstand 65,5), je 15 cm Anschlusslitze an beiden Enden (230 V braun/blau, 24 V rot/schwarz), Schutzklasse II' },
  { id: 'sea8', name: 'Snappy SEA8-24VL', w: 8, L: 101, W: 39.5, T: 19.5, end: 15, price: 10, note: '8 W, 0,33 A, 101 × 39,5 × 19,5 mm, Schutzklasse II, Schraubklemmen an den Enden — flach (Maßzeichnung vor dem Kauf prüfen)' },
  { id: 'apv12', name: 'Mean Well APV-12-24', w: 12, L: 90, W: 40, T: 29, end: 12, price: 11, note: '12 W, 0,5 A, Gehäuse 77 × 40 × 29 mm, mit Laschen 90 mm (Lochabstand 82,5), je 15 cm Anschlusslitze an beiden Enden, Schutzklasse II' },
  { id: 'loox20', name: 'Häfele Loox5 24 V 20 W slim (833.95.026)', w: 20, L: 140, W: 50, T: 16, end: 20, price: 35, note: '20 W, 140 × 50 × 16 mm, für den Möbeleinbau, Steckanschlüsse' },
]

// Dimmers between supply and strips (24-V side only).
export const DIMMERS = {
  zigbee: { id: 'zigbee', name: 'Zigbee-LED-Controller Gledopto GL-C-002P', L: 70, W: 36, T: 10, end: 12, price: 20, standby: 0.5, note: '70 × 36 × 10 mm, 5–24 V, 5-in-1 — auf 1 Farbe (Dimmer) stellen. Läuft mit zigbee2mqtt, ZHA und der Hue Bridge; nachts 10 %, bei Bewegung hell.' },
  pwm: { id: 'pwm', name: 'Mini-PWM-Dimmer 12–24 V mit Drehregler', L: 45, W: 20, T: 12, end: 10, price: 6, standby: 0.1, note: 'Helligkeit einmal einstellen, dann bleibt er verborgen. Maße schwanken je nach Hersteller — vor dem Kauf prüfen (ca. 45 × 20 × 12 mm geplant).' },
}

// COB strips: W per metre → name; lumen per watt by colour temperature (CRI ≥ 90, cautious).
export const STRIP_POWER = [
  { value: '5', label: '5 W/m — Nachtlicht, sanft' },
  { value: '10', label: '10 W/m — hell' },
]
export const STRIP_CCT = [
  { value: '2200', label: '2200 K — bernsteinwarm, für die Nacht' },
  { value: '2700', label: '2700 K — warmweiß' },
]
export const LM_PER_W = { 2200: 80, 2700: 95, 3000: 100 }

export const HEADROOM = 1.25 // a supply runs cool and long below 80 % load

/**
 * The supply that fits: enough power (load × headroom), placed by `place(supply)` which
 * returns a layout with a `score` (lower = less added size) or null when it does not fit.
 * Falls back to the strongest supply that places at all.
 */
export function pickSupply(load, place) {
  const need = load * HEADROOM
  const options = SUPPLIES.map((s) => ({ s, at: place(s) })).filter((o) => o.at)
  const ok = options.filter((o) => o.s.w >= need)
  const pool = ok.length ? ok : options.sort((a, b) => b.s.w - a.s.w).slice(0, 1)
  pool.sort((a, b) => a.at.score - b.at.score || a.s.price - b.s.price)
  const best = pool[0] || { s: SUPPLIES[0], at: place(SUPPLIES[0]) || {} }
  return { supply: best.s, ...best.at, enough: best.s.w >= need }
}

/** Strip load (W) and estimated light (lm) out of the lamp. */
export function stripLight(totalLengthMm, wpm, cct, optics) {
  const watt = (totalLengthMm / 1000) * wpm
  return { watt: Math.round(watt * 10) / 10, lumen: Math.round(watt * (LM_PER_W[cct] || 90) * optics) }
}
